$shm_hitalama_map_method_source_view $mol_page
	map $shm_hitalama_map
	source? \
	head /
		<= Tools $mol_view
			sub /
				<= Export $mol_button_major
					sub /
						<= Export_icon $mol_icon_upload
						\Экспорт
					click? <=> export? null
				<= Import $mol_button_minor
					sub /
						<= Import_icon $mol_icon_download
						\Импорт
					click? <=> import? null
				<= Layout_methods $mol_button_minor
					sub /
						<= Layout_methods_icon $mol_icon_apps
						\Расставить
					click? <=> layout_methods? null
	body /
		<= Source $shm_hitalama_textarea
			hint \method source
			sidebar_showed true
			value? <=> source? \
			spellcheck false
